/* Info component on advising users about the link  */
import React from 'react';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../../../styles/Callsheets.module.css";

const CopyLinkInfo = () => {
  return (
    <div>
        <Row className="my-3">
        <Col md={{span: 10, offset: 1}}>
        <div className={`px-3 py-2 ${styles.SubTitle6 }`}>
        <h5 className={`text-center `} >COPY EMAILS INFO</h5>  
        <hr className={`mt-2 mb-0`}/> 
          <p className="pt-2"><span className={`${styles.Red}`}>*</span> Copy the URL below and <span className={`${styles.Red}`}>Send</span> it to 
          all Crew and Cast needed for the Shoot Day.</p>
            <hr className={`mt-2 mb-0`}/> 
         </div> 
        </Col>
      </Row>
    </div>
  )
}

export default CopyLinkInfo